import { Minus, Plus } from "lucide-react";

// Number input with clearly visible white bold +/- steppers for dark navy forms.
export const NumStepper = ({ label, value, onChange, step = 1, min = 0, disabled = false, testid, unit, placeholder }) => {
  const st = Number(step);
  const safeStep = Number.isFinite(st) && st > 0 ? st : 1;
  const nudge = (dir) => {
    if (disabled) return;
    const cur = Number(value);
    const next = Math.max(min, Math.round(((Number.isFinite(cur) ? cur : 0) + dir * safeStep) * 1000) / 1000);
    onChange(String(next));
  };
  const btn = "h-[38px] w-8 shrink-0 flex items-center justify-center border border-white/25 text-white font-bold hover:bg-white hover:text-ink transition-colors duration-200 disabled:opacity-30 disabled:cursor-not-allowed";
  return (
    <div>
      {label && <label className="font-mono text-[10px] tracking-[0.2em] uppercase text-white font-semibold">{label}</label>}
      <div className="mt-1 flex items-stretch gap-1.5">
        <button type="button" data-testid={`${testid}-dec`} onClick={() => nudge(-1)} disabled={disabled} aria-label="Decrease" className={btn}>
          <Minus size={15} strokeWidth={3} />
        </button>
        <input
          data-testid={testid}
          type="number"
          step={step}
          min={min}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          className={`w-full min-w-0 bg-transparent border-0 border-b py-2 text-center font-body text-sm font-semibold placeholder:text-white/25 focus:outline-none transition-colors duration-300 ${disabled ? "border-white/10 text-white/40 cursor-not-allowed" : "border-white/25 text-white focus:border-[#7FB3E8]"}`}
        />
        <button type="button" data-testid={`${testid}-inc`} onClick={() => nudge(1)} disabled={disabled} aria-label="Increase" className={btn}>
          <Plus size={15} strokeWidth={3} />
        </button>
        {unit}
      </div>
    </div>
  );
};
